import { render, staticRenderFns } from "./ChangePasswordDialog.vue?vue&type=template&id=0b67e0bc&"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports